<template>
  <span class="Modal-title">{{ ModalTitle }}</span>
</template>

<script>

export default {

  name: "ModalCalendarTitle",

  props: {
    deliveryType: {
        type: String,
        default: '',
    },
    fromLanding: {
        type: Boolean,
        default: false,
    },
    landingLeadType: {
        type: String,
        default: '',
    }, 
    landingCategoryName: {
        type: String,
        default: '',
    },
    slotsChoiceActive: {
        type: Boolean,
        default: true,
    }
  },

  computed: {
    ModalTitle() {
        if (this.isLead || this.fromLanding) {
            return this.getLeadOrLandingTitle();
        } else {
            return this.getDeliveryTypeTitle(this.deliveryType)
        }
    },
  },
  

  methods: {
    
    getLeadOrLandingTitle() {
        const landingsWithoutCalendarSlots = this.fromLanding && !this.slotsChoiceActive;

        if(landingsWithoutCalendarSlots) {
            return this.landingCategoryName != "" ? 
                            `Devis ${this.landingCategoryName.toLowerCase()}` : 'Obtenir un devis';

        } else if(this.getSpecificLandingTitle(this.landingCategoryName)) {
            return this.getSpecificLandingTitle(this.landingCategoryName);

        } else {
            return this.landingLeadType == "VIDEO_ASSISTANCE" ? 
                            "Planifier mon rendez-vous de visio-assistance" : "Planifier ma visite technique";
        }
    },

    getSpecificLandingTitle(landingCategoryName) {
        let title = '';
        const specificLandingTitle = {
            "Planifier mon rendez-vous téléphonique":   ["Chauffe-eau électrique"],
            "Planifier mon appel technique":            ["Chauffe-eau thermodynamique"],
        }

        Object.entries(specificLandingTitle).forEach(([key, value]) => {
            if(value.includes(landingCategoryName)) title = key;
        })

        return title;
    },

    getDeliveryTypeTitle(deliveryType) {
        let title = '';
        const deliveryTypeTitles = {
            "Planifier ma livraison":                       ["delivery_only", "standard_delivery"],
            "Planifier mon intervention":                   ["intervention"],
            "Configurer et planifier mon installation":     ["installation", "delivery_and_installation"]      
        }
        
        Object.entries(deliveryTypeTitles).forEach(([key, value]) => {
            if(value.includes(deliveryType)) title = key;
        })

        return title;
    }
  },
  
};
</script>
